/**
 * Action types for reporting module
 */

// Created vs Resolved Report
export const FETCH_CREATED_VS_RESOLVED = 'FETCH_CREATED_VS_RESOLVED';
export const FETCH_CREATED_VS_RESOLVED_SUCCESS = 'FETCH_CREATED_VS_RESOLVED_SUCCESS';
export const FETCH_CREATED_VS_RESOLVED_FAIL = 'FETCH_CREATED_VS_RESOLVED_FAIL';

// Created Work Orders List
export const FETCH_CREATED_WORK_ORDERS = 'FETCH_CREATED_WORK_ORDERS';
export const FETCH_CREATED_WORK_ORDERS_SUCCESS = 'FETCH_CREATED_WORK_ORDERS_SUCCESS';
export const FETCH_CREATED_WORK_ORDERS_FAIL = 'FETCH_CREATED_WORK_ORDERS_FAIL';

// Resolved Work Orders List
export const FETCH_RESOLVED_WORK_ORDERS = 'FETCH_RESOLVED_WORK_ORDERS';
export const FETCH_RESOLVED_WORK_ORDERS_SUCCESS = 'FETCH_RESOLVED_WORK_ORDERS_SUCCESS';
export const FETCH_RESOLVED_WORK_ORDERS_FAIL = 'FETCH_RESOLVED_WORK_ORDERS_FAIL';

// Date Range
export const SET_REPORT_DATE_RANGE = 'SET_REPORT_DATE_RANGE';

// Clear Work Order List
export const CLEAR_WORK_ORDER_LIST = 'CLEAR_WORK_ORDER_LIST';

// Work Orders by Type Report
export const FETCH_WORK_ORDERS_BY_TYPE = 'FETCH_WORK_ORDERS_BY_TYPE';
export const FETCH_WORK_ORDERS_BY_TYPE_SUCCESS = 'FETCH_WORK_ORDERS_BY_TYPE_SUCCESS';
export const FETCH_WORK_ORDERS_BY_TYPE_FAIL = 'FETCH_WORK_ORDERS_BY_TYPE_FAIL';

// Work Orders by Type List
export const FETCH_WORK_ORDERS_BY_TYPE_LIST = 'FETCH_WORK_ORDERS_BY_TYPE_LIST';
export const FETCH_WORK_ORDERS_BY_TYPE_LIST_SUCCESS = 'FETCH_WORK_ORDERS_BY_TYPE_LIST_SUCCESS';
export const FETCH_WORK_ORDERS_BY_TYPE_LIST_FAIL = 'FETCH_WORK_ORDERS_BY_TYPE_LIST_FAIL';

// Repeating Report
export const FETCH_REPEATING_REPORT = 'FETCH_REPEATING_REPORT';
export const FETCH_REPEATING_REPORT_SUCCESS = 'FETCH_REPEATING_REPORT_SUCCESS';
export const FETCH_REPEATING_REPORT_FAIL = 'FETCH_REPEATING_REPORT_FAIL';

// Repeating Report List
export const FETCH_REPEATING_REPORT_LIST = 'FETCH_REPEATING_REPORT_LIST';
export const FETCH_REPEATING_REPORT_LIST_SUCCESS = 'FETCH_REPEATING_REPORT_LIST_SUCCESS';
export const FETCH_REPEATING_REPORT_LIST_FAIL = 'FETCH_REPEATING_REPORT_LIST_FAIL';

// Status Report
export const FETCH_STATUS_REPORT = 'FETCH_STATUS_REPORT';
export const FETCH_STATUS_REPORT_SUCCESS = 'FETCH_STATUS_REPORT_SUCCESS';
export const FETCH_STATUS_REPORT_FAIL = 'FETCH_STATUS_REPORT_FAIL';

// Status Report List
export const FETCH_STATUS_REPORT_LIST = 'FETCH_STATUS_REPORT_LIST';
export const FETCH_STATUS_REPORT_LIST_SUCCESS = 'FETCH_STATUS_REPORT_LIST_SUCCESS';
export const FETCH_STATUS_REPORT_LIST_FAIL = 'FETCH_STATUS_REPORT_LIST_FAIL';

// Priority Report
export const FETCH_PRIORITY_REPORT = 'FETCH_PRIORITY_REPORT';
export const FETCH_PRIORITY_REPORT_SUCCESS = 'FETCH_PRIORITY_REPORT_SUCCESS';
export const FETCH_PRIORITY_REPORT_FAIL = 'FETCH_PRIORITY_REPORT_FAIL';

// Priority Report List
export const FETCH_PRIORITY_REPORT_LIST = 'FETCH_PRIORITY_REPORT_LIST';
export const FETCH_PRIORITY_REPORT_LIST_SUCCESS = 'FETCH_PRIORITY_REPORT_LIST_SUCCESS';
export const FETCH_PRIORITY_REPORT_LIST_FAIL = 'FETCH_PRIORITY_REPORT_LIST_FAIL';

// Time to Complete Report
export const FETCH_TIME_TO_COMPLETE = 'FETCH_TIME_TO_COMPLETE';
export const FETCH_TIME_TO_COMPLETE_SUCCESS = 'FETCH_TIME_TO_COMPLETE_SUCCESS';
export const FETCH_TIME_TO_COMPLETE_FAIL = 'FETCH_TIME_TO_COMPLETE_FAIL';

// Time to Complete - Completed Work Orders List
export const FETCH_COMPLETED_WORK_ORDERS = 'FETCH_COMPLETED_WORK_ORDERS';
export const FETCH_COMPLETED_WORK_ORDERS_SUCCESS = 'FETCH_COMPLETED_WORK_ORDERS_SUCCESS';
export const FETCH_COMPLETED_WORK_ORDERS_FAIL = 'FETCH_COMPLETED_WORK_ORDERS_FAIL';

// Time to Complete - MTTR Work Orders List
export const FETCH_MTTR_WORK_ORDERS = 'FETCH_MTTR_WORK_ORDERS';
export const FETCH_MTTR_WORK_ORDERS_SUCCESS = 'FETCH_MTTR_WORK_ORDERS_SUCCESS';
export const FETCH_MTTR_WORK_ORDERS_FAIL = 'FETCH_MTTR_WORK_ORDERS_FAIL';

// On Time vs Overdue Report
export const FETCH_ON_TIME_OVERDUE = 'FETCH_ON_TIME_OVERDUE';
export const FETCH_ON_TIME_OVERDUE_SUCCESS = 'FETCH_ON_TIME_OVERDUE_SUCCESS';
export const FETCH_ON_TIME_OVERDUE_FAIL = 'FETCH_ON_TIME_OVERDUE_FAIL';

// On Time vs Overdue List
export const FETCH_ON_TIME_OVERDUE_LIST = 'FETCH_ON_TIME_OVERDUE_LIST';
export const FETCH_ON_TIME_OVERDUE_LIST_SUCCESS = 'FETCH_ON_TIME_OVERDUE_LIST_SUCCESS';
export const FETCH_ON_TIME_OVERDUE_LIST_FAIL = 'FETCH_ON_TIME_OVERDUE_LIST_FAIL';

// Completed by User Report
export const FETCH_COMPLETED_BY_USER = 'FETCH_COMPLETED_BY_USER';
export const FETCH_COMPLETED_BY_USER_SUCCESS = 'FETCH_COMPLETED_BY_USER_SUCCESS';
export const FETCH_COMPLETED_BY_USER_FAIL = 'FETCH_COMPLETED_BY_USER_FAIL';

// Completed by User List
export const FETCH_COMPLETED_BY_USER_LIST = 'FETCH_COMPLETED_BY_USER_LIST';
export const FETCH_COMPLETED_BY_USER_LIST_SUCCESS = 'FETCH_COMPLETED_BY_USER_LIST_SUCCESS';
export const FETCH_COMPLETED_BY_USER_LIST_FAIL = 'FETCH_COMPLETED_BY_USER_LIST_FAIL';

// Status Duration Report
export const FETCH_STATUS_DURATION_REPORT = 'FETCH_STATUS_DURATION_REPORT';
export const FETCH_STATUS_DURATION_REPORT_SUCCESS = 'FETCH_STATUS_DURATION_REPORT_SUCCESS';
export const FETCH_STATUS_DURATION_REPORT_FAIL = 'FETCH_STATUS_DURATION_REPORT_FAIL';

// Asset Performance Report
export const FETCH_ASSET_PERFORMANCE = 'FETCH_ASSET_PERFORMANCE';
export const FETCH_ASSET_PERFORMANCE_SUCCESS = 'FETCH_ASSET_PERFORMANCE_SUCCESS';
export const FETCH_ASSET_PERFORMANCE_FAIL = 'FETCH_ASSET_PERFORMANCE_FAIL';

// Recent Activity Report
export const FETCH_RECENT_ACTIVITY = 'FETCH_RECENT_ACTIVITY';
export const FETCH_RECENT_ACTIVITY_SUCCESS = 'FETCH_RECENT_ACTIVITY_SUCCESS';
export const FETCH_RECENT_ACTIVITY_FAIL = 'FETCH_RECENT_ACTIVITY_FAIL';

// Recent Activity Load More (appends groups)
export const FETCH_RECENT_ACTIVITY_MORE = 'FETCH_RECENT_ACTIVITY_MORE';
export const FETCH_RECENT_ACTIVITY_MORE_SUCCESS = 'FETCH_RECENT_ACTIVITY_MORE_SUCCESS';
export const FETCH_RECENT_ACTIVITY_MORE_FAIL = 'FETCH_RECENT_ACTIVITY_MORE_FAIL';

// Recent Activity Filters
export const SET_RECENT_ACTIVITY_FILTERS = 'SET_RECENT_ACTIVITY_FILTERS';
export const CLEAR_RECENT_ACTIVITY = 'CLEAR_RECENT_ACTIVITY';

// Asset Health: Current Status Report
export const FETCH_CURRENT_STATUS = 'FETCH_CURRENT_STATUS';
export const FETCH_CURRENT_STATUS_SUCCESS = 'FETCH_CURRENT_STATUS_SUCCESS';
export const FETCH_CURRENT_STATUS_FAIL = 'FETCH_CURRENT_STATUS_FAIL';

// Asset Health: Most Problematic Assets Report
export const FETCH_MOST_PROBLEMATIC = 'FETCH_MOST_PROBLEMATIC';
export const FETCH_MOST_PROBLEMATIC_SUCCESS = 'FETCH_MOST_PROBLEMATIC_SUCCESS';
export const FETCH_MOST_PROBLEMATIC_FAIL = 'FETCH_MOST_PROBLEMATIC_FAIL';

// Asset Health: Downtime Breakdown Report
export const FETCH_DOWNTIME_BREAKDOWN = 'FETCH_DOWNTIME_BREAKDOWN';
export const FETCH_DOWNTIME_BREAKDOWN_SUCCESS = 'FETCH_DOWNTIME_BREAKDOWN_SUCCESS';
export const FETCH_DOWNTIME_BREAKDOWN_FAIL = 'FETCH_DOWNTIME_BREAKDOWN_FAIL';

// Asset Health: Total Downtime Report
export const FETCH_TOTAL_DOWNTIME = 'FETCH_TOTAL_DOWNTIME';
export const FETCH_TOTAL_DOWNTIME_SUCCESS = 'FETCH_TOTAL_DOWNTIME_SUCCESS';
export const FETCH_TOTAL_DOWNTIME_FAIL = 'FETCH_TOTAL_DOWNTIME_FAIL';

// Asset Health: Downtime Cost Report
export const FETCH_DOWNTIME_COST = 'FETCH_DOWNTIME_COST';
export const FETCH_DOWNTIME_COST_SUCCESS = 'FETCH_DOWNTIME_COST_SUCCESS';
export const FETCH_DOWNTIME_COST_FAIL = 'FETCH_DOWNTIME_COST_FAIL';

// Work Order Cost Report (labor / parts / contractor)
export const FETCH_WORK_ORDER_COST_REPORT = 'FETCH_WORK_ORDER_COST_REPORT';
export const FETCH_WORK_ORDER_COST_REPORT_SUCCESS = 'FETCH_WORK_ORDER_COST_REPORT_SUCCESS';
export const FETCH_WORK_ORDER_COST_REPORT_FAIL = 'FETCH_WORK_ORDER_COST_REPORT_FAIL';

// Asset Health: Maintenance Spend by Asset (top-N widget + expanded table)
export const FETCH_MAINTENANCE_SPEND_BY_ASSET = 'FETCH_MAINTENANCE_SPEND_BY_ASSET';
export const FETCH_MAINTENANCE_SPEND_BY_ASSET_SUCCESS = 'FETCH_MAINTENANCE_SPEND_BY_ASSET_SUCCESS';
export const FETCH_MAINTENANCE_SPEND_BY_ASSET_FAIL = 'FETCH_MAINTENANCE_SPEND_BY_ASSET_FAIL';

// CSV Export
export const EXPORT_CSV = 'EXPORT_CSV';
export const EXPORT_CSV_SUCCESS = 'EXPORT_CSV_SUCCESS';
export const EXPORT_CSV_FAIL = 'EXPORT_CSV_FAIL';
export const CLEAR_EXPORT_STATE = 'CLEAR_EXPORT_STATE';

// Global CSV Export (cross-org via Global View)
export const EXPORT_GLOBAL_CSV = 'EXPORT_GLOBAL_CSV';
